const ROW_WIDTH = 12;
const separateFields = (fields)=>{
    const visibleFields = fields.filter((field)=>!field.properties.hidden);
    const hiddenFields = fields.filter((field)=>field.properties.hidden);
    return {
        visibleFields,
        hiddenFields
    };
};
const createRowMap = (visibleFields)=>{
    const rowMap = {};
    visibleFields.forEach((field)=>{
        const row = field.layout.row;
        if (!rowMap[row]) {
            rowMap[row] = [];
        }
        rowMap[row].push(field);
    });
    return rowMap;
};
const findRowsWithGaps = (rowMap)=>{
    const rowsWithGaps = {};
    Object.keys(rowMap).forEach((rowKey)=>{
        const row = parseInt(rowKey, 10);
        const fieldsInRow = rowMap[row];
        const totalWidth = fieldsInRow.reduce((sum, field)=>sum + field.layout.width, 0);
        if (totalWidth !== ROW_WIDTH) {
            rowsWithGaps[row] = fieldsInRow;
        }
    });
    return rowsWithGaps;
};
const recalculateFieldLayouts = (fields, rowsWithGaps)=>{
    return fields.map((field)=>{
        const row = field.layout.row;
        if (rowsWithGaps[row] && !field.properties.hidden) {
            const fieldsInRow = rowsWithGaps[row];
            const fieldCount = fieldsInRow.length;
            const newWidth = ROW_WIDTH / fieldCount;
            const fieldPosition = fieldsInRow.findIndex((f)=>f.id === field.id);
            const newColumn = newWidth * fieldPosition;
            return {
                ...field,
                layout: {
                    ...field.layout,
                    width: newWidth,
                    column: newColumn
                }
            };
        }
        return field;
    });
};
const moveHiddenFieldsToBottom = (fields, visibleFields, hiddenFields)=>{
    const maxVisibleRow = Math.max(...visibleFields.map((field)=>field.layout.row), -1);
    return fields.map((field)=>{
        if (field.properties.hidden) {
            const hiddenFieldIndex = hiddenFields.findIndex((f)=>f.id === field.id);
            return {
                ...field,
                layout: {
                    ...field.layout,
                    row: maxVisibleRow + 1 + hiddenFieldIndex
                }
            };
        }
        return field;
    });
};
export const removeGaps = (baseForm)=>{
    const { visibleFields, hiddenFields } = separateFields(baseForm.fields);
    const rowMap = createRowMap(visibleFields);
    const rowsWithGaps = findRowsWithGaps(rowMap);
    const fieldsWithRecalculatedLayouts = recalculateFieldLayouts(baseForm.fields, rowsWithGaps);
    const fieldsWithHiddenMoved = moveHiddenFieldsToBottom(fieldsWithRecalculatedLayouts, visibleFields, hiddenFields);
    return {
        ...baseForm,
        fields: fieldsWithHiddenMoved
    };
};

//# sourceMappingURL=remove-gaps.js.map